import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import Home from "./pages/Home";
import Golf from "./pages/Golf";
import Events from "./pages/Events";
import Weddings from "./pages/Weddings";
import PubGrill from "./pages/PubGrill";
import Contact from "./pages/Contact";
import Memberships from "./pages/Memberships";
import CorporateMemberships from "./pages/CorporateMemberships";
import Leagues from "./pages/Leagues";
import JuniorPrograms from "./pages/JuniorPrograms";
import LadiesClinics from "./pages/LadiesClinics";
import GolfLessons from "./pages/GolfLessons";

import Booking from "./pages/Booking";
import Order from "./pages/Order";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/golf" element={<Golf />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/order" element={<Order />} />
            <Route path="/events" element={<Events />} />
            <Route path="/weddings" element={<Weddings />} />
            <Route path="/pub-grill" element={<PubGrill />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/memberships" element={<Memberships />} />
            <Route path="/corporate-memberships" element={<CorporateMemberships />} />
            <Route path="/leagues" element={<Leagues />} />
            <Route path="/junior-programs" element={<JuniorPrograms />} />
            <Route path="/ladies-clinics" element={<LadiesClinics />} />
            <Route path="/golf-lessons" element={<GolfLessons />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
